import axios from 'axios';
import BasicService from './basic.service'

class AuthService extends BasicService {
    login(user, channelId, token) {
        return axios
            .post(this.API_URL + 'auth/signin', {
                dbid: user.dbid,
                channelId: channelId,
                token: token,
            })
            .then(response => {
                if (response.data.user.accessToken) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    localStorage.setItem('premiumChannel', JSON.stringify(response.data.premiumChannel));
                    localStorage.setItem('pagesEnabled', JSON.stringify(response.data.pagesEnabled));
                }

                return response.data;
            });
    }
    
    websiteLogin(dbid, token) {
        return axios
            .post(this.API_URL + 'auth/website/signin', {
                dbid: dbid,
                token: token
            })
            .then(response => {
                if (response.data.user.accessToken) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    localStorage.setItem('premiumChannel', JSON.stringify(response.data.premiumChannel));
                    localStorage.setItem('pagesEnabled', JSON.stringify(response.data.pagesEnabled));
                }
                
                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('premiumChannel');
        localStorage.removeItem('pagesEnabled');
    }

    getClients() {
        return axios
            .get(this.API_URL + 'auth/getClients', )
            .then(response => {
                return response.data;
            });
    }

    sentToken(user, channelId) {
        return axios
            .post(this.API_URL + 'auth/sentToken', {
                dbid: user.dbid,
                channelId: channelId
            })
            .then(response => {
                return response.data;
            });
    }
}

export default new AuthService();